import React from "react";
import TechTag from "./TechTag";

const WorkItem = ({ item }) => {
  return (
    <div className="work__card">
      <div key={item.id}>
        <div
          style={{ backgroundImage: `url(${item.image})` }}
          className="work__img"
        ></div>
        <h3 className="work__title">{item.title}</h3>
      </div>
      <div className="tech__tag-container">
        {item.technology_tags.map((tch, idx) => (
          <TechTag tag={tch} key={idx} />
        ))}
      </div>
      <div className="work__item__footer">
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer"
          className="work__button"
        >
          Demo <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
        <a
          href={item.code}
          target="_blank"
          rel="noreferrer"
          className="work__button"
        >
          code <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
      </div>
    </div>
  );
};

export default WorkItem;
